var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.note),expression:"item.note"}],staticClass:"form-control",attrs:{"rows":"4"},domProps:{"value":(_vm.item.note)},on:{"input":function($event){if($event.target.composing)return;_vm.$set(_vm.item, "note", $event.target.value)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }